import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const ThemeCtx = createContext({
  isDark: true,
  setTheme: () => {},
  toggleTheme: () => {},
});

export function useTheme() {
  return useContext(ThemeCtx);
}

export function ThemeProvider({ children }) {
  const [isDark, setIsDark] = useState(true);
  const setTheme = useCallback((nextIsDark) => setIsDark(Boolean(nextIsDark)), []);
  const toggleTheme = useCallback(() => setIsDark((prev) => !prev), []);
  const value = useMemo(() => ({ isDark, setTheme, toggleTheme }), [isDark, setTheme, toggleTheme]);

  useEffect(() => {
    const className = "theme-dark";
    const root = document.documentElement;
    if (isDark) {
      root.classList.add(className);
    } else {
      root.classList.remove(className);
    }
  }, [isDark]);

  return <ThemeCtx.Provider value={value}>{children}</ThemeCtx.Provider>;
}

export default ThemeCtx;
